export const NAMESET={
  USERNAME:"username",
  PASSWORD:"password",
  REMEMBER:"remember",
  REJECT_REASON_CUSTOM:"reject_reason_custom"
}